/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2 8L2 20"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.7451 1.25489L7.81178 6.18822C6.77406 7.22593 6.25521 7.74479 5.88416 8.35029C5.55519 8.88712 5.31276 9.47239 5.16578 10.0846C5 10.7751 5 11.5089 5 12.9764V16.2C5 17.8802 5 18.7202 5.32698 19.362C5.6146 19.9265 6.07354 20.3854 6.63803 20.673C7.27976 21 8.11984 21 9.8 21H16.882C18.3435 21 19.0742 21 19.6644 20.7326C20.1846 20.4969 20.6267 20.1176 20.9388 19.6393C21.2928 19.0966 21.4039 18.3744 21.6262 16.9299L22.1493 13.5299C22.4424 11.6247 22.5889 10.6721 22.3062 9.93088C22.0581 9.28031 21.5914 8.73631 20.9861 8.39213C20.2965 8 19.3327 8 17.4051 8H16.2639C15.3864 8 14.9476 8 14.6502 7.86375C14.1289 7.62501 13.7894 7.11006 13.7753 6.53693C13.7672 6.20985 13.94 5.80657 14.2857 5L14.9602 3.42611C15.4525 2.27761 14.61 1 13.3605 1C13.1297 1 12.9083 1.09169 12.7451 1.25489Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M12.5449 1.4551L7.81178 6.18822C6.77406 7.22593 6.25521 7.74479 5.88416 8.35029C5.55519 8.88712 5.31276 9.47239 5.16578 10.0846C5 10.7751 5 11.5089 5 12.9764V16.2C5 17.8802 5 18.7202 5.32698 19.362C5.6146 19.9265 6.07354 20.3854 6.63803 20.673C7.27976 21 8.11984 21 9.8 21H16.882C18.3435 21 19.0742 21 19.6644 20.7326C20.1846 20.4969 20.6267 20.1176 20.9388 19.6393C21.2928 19.0966 21.4039 18.3744 21.6262 16.9299L22.1493 13.5299C22.4424 11.6247 22.5889 10.6721 22.3062 9.93088C22.0581 9.28031 21.5914 8.73631 20.9861 8.39213C20.2965 8 19.3327 8 17.4051 8H16.2639C15.3864 8 14.9476 8 14.6502 7.86375C14.1289 7.62501 13.7894 7.11006 13.7753 6.53693C13.7672 6.20985 13.94 5.80657 14.2857 5L15.0718 3.16587C15.5112 2.14057 14.7591 1 13.6436 1C13.2315 1 12.8363 1.1637 12.5449 1.4551Z"
				fill="currentColor"
			/>
			<path
				d="M2 8L2 20M9.8 21H16.882C18.3435 21 19.0742 21 19.6644 20.7326C20.1846 20.4969 20.6267 20.1176 20.9388 19.6393C21.2928 19.0966 21.4039 18.3744 21.6262 16.9299L22.1492 13.5299C22.4424 11.6247 22.5889 10.6721 22.3062 9.93088C22.0581 9.28031 21.5914 8.73631 20.9861 8.39213C20.2965 8 19.3327 8 17.4051 8H16.2639C15.3864 8 14.9476 8 14.6502 7.86375C14.1289 7.62501 13.7894 7.11006 13.7753 6.53693C13.7672 6.20985 13.94 5.80657 14.2857 5L14.9602 3.42611C15.4525 2.27761 14.61 1 13.3605 1V1C13.1297 1 12.9083 1.09169 12.7451 1.25489L7.81178 6.18822C6.77406 7.22594 6.25521 7.74479 5.88416 8.35029C5.55519 8.88712 5.31276 9.47239 5.16578 10.0846C5 10.7751 5 11.5089 5 12.9764V16.2C5 17.8802 5 18.7202 5.32698 19.362C5.6146 19.9265 6.07354 20.3854 6.63803 20.673C7.27976 21 8.11984 21 9.8 21Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.5264 0.412914C12.6307 0.308602 12.7722 0.25 12.9197 0.25C14.9163 0.25 16.2625 2.29148 15.476 4.12665L14.6374 6.08333C14.4007 6.63562 14.8058 7.25 15.4067 7.25H16.5272C18.9924 7.25 20.225 7.25 21.116 7.73236C21.9829 8.20166 22.646 8.97457 22.9781 9.90277C23.3193 10.8568 23.1319 12.0751 22.757 14.5116L22.4783 16.3232C22.182 18.2491 22.0339 19.2121 21.5618 19.9357C21.1457 20.5734 20.5562 21.0791 19.8627 21.3934C19.0757 21.75 18.1014 21.75 16.1528 21.75H10.65C8.40979 21.75 7.28968 21.75 6.43404 21.314C5.68139 20.9305 5.06947 20.3186 4.68597 19.566C4.25 18.7103 4.25 17.5902 4.25 15.35V12.6658C4.25 11.1982 4.25 10.4645 4.41578 9.77395C4.56276 9.16173 4.80519 8.57646 5.13416 8.03963C5.50521 7.43413 6.02407 6.91527 7.06178 5.87756L12.5264 0.412914ZM2.75 8C2.75 7.58579 2.41421 7.25 2 7.25C1.58579 7.25 1.25 7.58579 1.25 8V20C1.25 20.4142 1.58579 20.75 2 20.75C2.41421 20.75 2.75 20.4142 2.75 20L2.75 8Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M5 13V12V12C5 11.4941 5 11.2412 5.01983 10.9978C5.12184 9.74635 5.61391 8.55841 6.42671 7.60134C6.58474 7.41526 6.7636 7.2364 7.12132 6.87868L12.7451 1.25489C12.9083 1.09169 13.1297 1 13.3605 1V1C14.61 1 15.4525 2.27761 14.9602 3.42611L14.2857 5C13.94 5.80657 13.7672 6.20985 13.7753 6.53693C13.7894 7.11006 14.1289 7.62501 14.6502 7.86375C14.9476 8 15.3864 8 16.2639 8H17.4051C19.3327 8 20.2965 8 20.9861 8.39213C21.5914 8.73631 22.0581 9.28031 22.3062 9.93088C22.5889 10.6721 22.4424 11.6247 22.1492 13.5299L21.6262 16.9299C21.4039 18.3744 21.2928 19.0966 20.9388 19.6393C20.6267 20.1176 20.1846 20.4969 19.6644 20.7326C19.0742 21 18.3435 21 16.882 21H8C6.34315 21 5 19.6569 5 18V18V17M2 9L2 17C2 17.9319 2 18.3978 2.15224 18.7654C2.35523 19.2554 2.74458 19.6448 3.23463 19.8478C3.60218 20 4.06812 20 5 20V20H5.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 8L2 20M9.8 21H16.882C18.3435 21 19.0742 21 19.6644 20.7326C20.1846 20.4969 20.6267 20.1176 20.9388 19.6393C21.2928 19.0966 21.4039 18.3744 21.6262 16.9299L22.1492 13.5299C22.4424 11.6247 22.5889 10.6721 22.3062 9.93088C22.0581 9.28031 21.5914 8.73631 20.9861 8.39213C20.2965 8 19.3327 8 17.4051 8H16.2639C15.3864 8 14.9476 8 14.6502 7.86375C14.1289 7.62501 13.7894 7.11006 13.7753 6.53693C13.7672 6.20985 13.94 5.80657 14.2857 5L14.9602 3.42611C15.4525 2.27761 14.61 1 13.3605 1V1C13.1297 1 12.9083 1.09169 12.7451 1.25489L7.81178 6.18822C6.77406 7.22594 6.25521 7.74479 5.88416 8.35029C5.55519 8.88712 5.31276 9.47239 5.16578 10.0846C5 10.7751 5 11.5089 5 12.9764V16.2C5 17.8802 5 18.7202 5.32698 19.362C5.6146 19.9265 6.07354 20.3854 6.63803 20.673C7.27976 21 8.11984 21 9.8 21Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12.9197 0.25C12.7722 0.25 12.6307 0.308602 12.5264 0.412914L7.06177 5.87756C6.02406 6.91527 5.50521 7.43413 5.13416 8.03963C4.80519 8.57646 4.56276 9.16173 4.41578 9.77395C4.25 10.4645 4.25 11.1982 4.25 12.6658V15.35C4.25 17.5902 4.25 18.7103 4.68597 19.566C5.06947 20.3186 5.68139 20.9305 6.43404 21.314C7.28969 21.75 8.40979 21.75 10.65 21.75H16.1528C18.1014 21.75 19.0757 21.75 19.8627 21.3934C20.5562 21.0791 21.1457 20.5734 21.5618 19.9357C22.0339 19.2121 22.182 18.2491 22.4783 16.3232L22.757 14.5116C23.1319 12.0751 23.3193 10.8568 22.9781 9.90277C22.646 8.97457 21.9829 8.20166 21.116 7.73236C20.225 7.25 18.9924 7.25 16.5272 7.25H15.4067C14.8058 7.25 14.4007 6.63562 14.6374 6.08333L15.476 4.12665C16.2625 2.29148 14.9163 0.25 12.9197 0.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 7.25C2.41421 7.25 2.75 7.58579 2.75 8L2.75 20C2.75 20.4142 2.41421 20.75 2 20.75C1.58579 20.75 1.25 20.4142 1.25 20L1.25 8C1.25 7.58579 1.58579 7.25 2 7.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
